import { useEquipeDialog } from "./use-equipe-dialog";
import { EquipeDialogView } from "./view-equipe-dialog";
import type { EquipeDialogProps } from "./types-equipe-dialog";

export function EquipeDialog(props: EquipeDialogProps) {
  const vm = useEquipeDialog(props);

  return <EquipeDialogView {...props} {...vm} />;
}

export type * from "./types-equipe-dialog";
